import { CheckboxGroup as BaseCheckboxGroup } from '@base-ui/react/checkbox-group';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type CheckboxGroupProps = ComponentProps<typeof BaseCheckboxGroup>;

/**
 * Holds the checked values for a set of {@link Checkbox}es, including the
 * parent/child ("select all") relationship when `allValues` is passed.
 */
export function CheckboxGroup({ className, ...props }: CheckboxGroupProps) {
  return <BaseCheckboxGroup className={cx('flex flex-col gap-2', className)} {...props} />;
}
